import { useCallback, useEffect, useState } from 'react'

import { Post } from '@/model/post'
import fetchPosts from '@/util/fetchPosts'

const useFetchPosts = () => {
  const [page, setPage] = useState(0)
  const [hasNext, setHasNext] = useState(false)
  const [hasPrev, setHasPrev] = useState(false)
  const [posts, setPosts] = useState<Post[]>([])
  const [loading, setLoading] = useState(true)

  const fetchPostList = useCallback(async (page: number) => {
    setLoading(true)
    const url = `${process.env.NEXT_PUBLIC_KETHI_API}/blog/v1/posts?page=${page}&page_size=20`
    const { posts, next, prev } = await fetchPosts(url)
    setPosts(posts || [])
    setHasNext(next != null)
    setHasPrev(prev != null)
    setLoading(false)
  }, [])

  const fetchNextPage = useCallback(() => {
    setPage((prev) => prev + 1)
  }, [])

  const fetchPrevPage = useCallback(() => {
    setPage((prev) => prev - 1)
  }, [])

  useEffect(() => {
    if (page > 0) {
      fetchPostList(page)
    }
  }, [fetchPostList, page])

  useEffect(() => {
    setPage(1)
  }, [])

  return { posts, loading, hasPrev, hasNext, fetchNextPage, fetchPrevPage }
}

export default useFetchPosts
